import { IMAGES } from "./site";

export const ARTICLES = [
  {
    slug: "tesla-chauffeur-vs-taxi-brussels-airport",
    date: "2026-10-18",
    minutes: 3,
    image: IMAGES.front,
    t: {
      en: {
        title: "Tesla Chauffeur vs. Taxi at Brussels Airport: What Actually Changes",
        excerpt: "Silence, fixed protocol, flight tracking — the small differences that change an airport arrival.",
        body: [
          "Landing at Brussels Airport after a long flight, the difference between a taxi queue and a waiting chauffeur is not luxury for its own sake — it is the removal of friction at the exact moment you are most tired.",
          "A Tesla Model 3 waits in near silence. Your chauffeur tracks your flight, holds a name board at arrivals, and handles luggage without being asked. There is no meter running, no route negotiation, no engine noise on the ring road home.",
          "And because the fleet is fully electric, the quiet continues all the way to your door — a small detail that, after a red-eye, does not feel small at all."
        ]
      },
      fr: {
        title: "Chauffeur Tesla ou taxi à l'aéroport de Bruxelles : ce qui change vraiment",
        excerpt: "Silence, protocole fixe, suivi de vol — les petites différences qui transforment une arrivée.",
        body: [
          "Après un long vol, à l'aéroport de Bruxelles, la différence entre une file de taxis et un chauffeur qui vous attend n'est pas un luxe gratuit — c'est la suppression de la friction au moment précis où vous êtes le plus fatigué.",
          "Une Tesla Model 3 vous attend dans un silence presque total. Votre chauffeur suit votre vol, tient une pancarte à votre nom aux arrivées et s'occupe des bagages sans qu'on le lui demande. Pas de compteur, pas de négociation d'itinéraire, pas de bruit de moteur sur le ring.",
          "Et parce que la flotte est entièrement électrique, le calme vous accompagne jusqu'à votre porte — un détail qui, après un vol de nuit, n'a rien d'un détail."
        ]
      },
      nl: {
        title: "Tesla-chauffeur versus taxi op Brussels Airport: wat er echt verandert",
        excerpt: "Stilte, vast protocol, vluchttracking — de kleine verschillen die een aankomst veranderen.",
        body: [
          "Na een lange vlucht op Brussels Airport is het verschil tussen een taxirij en een wachtende chauffeur geen luxe om de luxe — het is het wegnemen van frictie op precies het moment dat je het moeist bent.",
          "Een Tesla Model 3 wacht in vrijwel totale stilte. Je chauffeur volgt je vlucht, houdt een naambord omhoog bij de aankomst en neemt de bagage over zonder dat je het vraagt. Geen lopende meter, geen route-onderhandeling, geen motorlawaai op de ring naar huis.",
          "En omdat de vloot volledig elektrisch is, blijft de stilte tot aan je deur — een detail dat na een nachtvlucht helemaal niet klein voelt."
        ]
      },
      ar: {
        title: "سائق تسلا أم تاكسي في مطار بروكسل: ما الذي يتغير فعلاً",
        excerpt: "صمت، بروتوكول ثابت، تتبع للرحلة — فروق صغيرة تغيّر وصولك في المطار.",
        body: [
          "بعد رحلة طويلة تهبط في مطار بروكسل، الفرق بين طابور التكاسي وسائق ينتظرك ليس رفاهية مجانية — بل إزالة العناء في اللحظة التي تكون فيها أشد تعباً.",
          "تنتظرك تسلا موديل 3 في صمت شبه تام. يتتبع سائقك رحلتك، ويحمل لوحة باسمك عند الوصول، ويتكفل بالأمتعة دون أن تطلب. لا عدّاد يعمل، ولا تفاوض على الطريق، ولا ضجيج محرك على الطريق الدائري.",
          "ولأن الأسطول كهربائي بالكامل، يرافقك الهدوء حتى باب منزلك — تفصيل صغير لا يبدو صغيراً بعد رحلة ليلية."
        ]
      }
    }
  },
  {
    slug: "eu-quarter-protocol-transport",
    date: "2026-10-12",
    minutes: 3,
    image: IMAGES.brussels,
    t: {
      en: {
        title: "Moving Delegations Through the EU Quarter: A Protocol Guide",
        excerpt: "Timing, discretion and local knowledge — how institutional transport actually works around Schuman.",
        body: [
          "The European Quarter runs on its own clock. Meetings shift, motorcades form, and a five-minute delay at Schuman can ripple through an entire afternoon of institutional diplomacy.",
          "Protocol transport is built for exactly this: chauffeurs who know every service entrance and drop-off lane, dispatchers who monitor schedules in real time, and vehicles quiet enough for a confidential call to continue uninterrupted from door to door.",
          "For delegations, the rule is simple — the car is not a detail of the visit. It is part of the visit."
        ]
      },
      fr: {
        title: "Transporter les délégations dans le Quartier européen : guide de protocole",
        excerpt: "Timing, discrétion et connaissance du terrain — comment fonctionne réellement le transport institutionnel autour de Schuman.",
        body: [
          "Le Quartier européen vit à sa propre heure. Les réunions glissent, les cortèges se forment, et cinq minutes de retard à Schuman peuvent faire basculer tout un après-midi de diplomatie institutionnelle.",
          "Le transport de protocole est conçu exactement pour cela : des chauffeurs qui connaissent chaque entrée de service et chaque voie de dépose, des dispatchers qui suivent les horaires en temps réel, et des véhicules assez silencieux pour qu'un appel confidentiel se poursuive sans interruption de porte à porte.",
          "Pour les délégations, la règle est simple — la voiture n'est pas un détail de la visite. Elle fait partie de la visite."
        ]
      },
      nl: {
        title: "Delegaties door de Europese wijk vervoeren: een protocolgids",
        excerpt: "Timing, discretie en terreinkennis — hoe institutioneel vervoer rond Schuman echt werkt.",
        body: [
          "De Europese wijk draait op haar eigen klok. Vergaderingen schuiven, colonnes vormen zich, en vijf minuten vertraging bij Schuman kan een hele namiddag institutionele diplomatie doorkruisen.",
          "Protocolvervoer is daar precies voor gebouwd: chauffeurs die elke dienstingang en uitstapstrook kennen, dispatchers die schema's realtime volgen, en voertuigen die stil genoeg zijn om een vertrouwelijk gesprek ononderbroken van deur tot deur te laten doorgaan.",
          "Voor delegaties is de regel eenvoudig — de auto is geen detail van het bezoek. Hij is onderdeel van het bezoek."
        ]
      },
      ar: {
        title: "نقل الوفود في الحي الأوروبي: دليل البروتوكول",
        excerpt: "توقيت وكتمان ومعرفة بالميدان — كيف يعمل النقل المؤسسي حول شومان فعلاً.",
        body: [
          "يعمل الحي الأوروبي بساعته الخاصة. الاجتماعات تتزحزح، والمواكب تتشكل، وخمس دقائق تأخير عند شومان قد تقلب ظهيرة كاملة من الدبلوماسية المؤسسية.",
          "النقل البروتوكولي مصمم لهذا تحديداً: سائقون يعرفون كل مدخل خدمة ومسار إنزال، وموجّهون يراقبون الجداول لحظياً، ومركبات هادئة بما يكفي ليستمر اتصال سري دون انقطاع من الباب إلى الباب.",
          "للوفود القاعدة بسيطة — السيارة ليست تفصيلاً من الزيارة، بل جزء منها."
        ]
      }
    }
  },
  {
    slug: "around-the-clock-concierge-chauffeur",
    date: "2026-10-05",
    minutes: 4,
    image: IMAGES.chauffeur,
    t: {
      en: {
        title: "Around the Clock: What a 24/24 Concierge Chauffeur Actually Does",
        excerpt: "The 4 a.m. pickup is planned at 9 p.m. the night before — a look behind round-the-clock service.",
        body: [
          "Most rides are booked days ahead. But the calls that define a chauffeur house arrive at midnight: a delayed flight, a ministerial dinner that ran long, a family that needs the airport before dawn.",
          "Round-the-clock concierge means someone always answers. Flights are tracked through the night, vehicles are charged and inspected while the city sleeps, and a driver is assigned with enough margin to be early — never just on time.",
          "It is less a schedule than a promise: whenever you move, we are already moving."
        ]
      },
      fr: {
        title: "24 heures sur 24 : ce que fait vraiment un chauffeur-concierge",
        excerpt: "La prise en charge de 4 h du matin est planifiée à 21 h la veille — dans les coulisses d'un service permanent.",
        body: [
          "La plupart des courses sont réservées des jours à l'avance. Mais les appels qui définissent une maison de chauffeurs arrivent à minuit : un vol retardé, un dîner ministériel qui s'éternise, une famille qui doit rejoindre l'aéroport avant l'aube.",
          "Une conciergerie permanente signifie que quelqu'un répond toujours. Les vols sont suivis toute la nuit, les véhicules sont chargés et inspectés pendant que la ville dort, et un chauffeur est assigné avec assez de marge pour être en avance — jamais simplement à l'heure.",
          "C'est moins un horaire qu'une promesse : quand vous bougez, nous sommes déjà en route."
        ]
      },
      nl: {
        title: "24/24 paraat: wat een concierge-chauffeur echt doet",
        excerpt: "De ophaal om 4 uur 's ochtends wordt om 21 uur de avond ervoor gepland — een kijkje achter de non-stop service.",
        body: [
          "De meeste ritten worden dagen vooraf geboekt. Maar de telefoontjes die een chauffeursdienst definiëren komen om middernacht: een vertraagde vlucht, een ministerieel diner dat uitloopt, een gezin dat vóór de dageraad naar de luchthaven moet.",
          "Non-stop conciërge betekent dat er altijd iemand opneemt. Vluchten worden de hele nacht gevolgd, voertuigen worden opgeladen en gecontroleerd terwijl de stad slaapt, en een chauffeur wordt ingepland met genoeg marge om vroeg te zijn — nooit zomaar op tijd.",
          "Het is minder een rooster dan een belofte: wanneer u beweegt, zijn wij al onderweg."
        ]
      },
      ar: {
        title: "على مدار الساعة: ماذا يفعل سائق الكونسيرج 24/24 فعلاً",
        excerpt: "موعد الرابعة فجراً يُخطط له التاسعة مساءً في الليلة السابقة — نظرة خلف خدمة لا تتوقف.",
        body: [
          "معظم المشاوير تُحجز قبل أيام. لكن المكالمات التي تصنع سمعة بيت السائقين تأتي منتصف الليل: رحلة متأخرة، عشاء وزاري طال، عائلة تحتاج المطار قبل الفجر.",
          "كونسيرج دائم يعني أن هناك من يرد دائماً. تُتتبَّع الرحلات طوال الليل، وتُشحن المركبات وتُفحص بينما تنام المدينة، ويُسنَد السائق بهامش كافٍ ليصل مبكراً — لا مجرد في الموعد.",
          "إنها ليست جدولاً بل وعداً: متى تحركت، نكون قد تحركنا قبلك."
        ]
      }
    }
  }
];

export const BLOG_SLUGS = ARTICLES.map((a) => a.slug);
